import { Label } from "@/components/ui/label";

export function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <Label className="mb-1.5 block text-xs">{label}</Label>
      {children}
    </div>
  );
}
